import {Button, useMediaQuery} from '@material-ui/core';
import ScheduleDetailsDrawer from 'Agent/Commissions/components/Schedules/ScheduleDetailsDrawer';
import {
  changeFilter,
  clear,
  clearDetails,
  clearFilters,
  getCommissionSchedules,
  loadDetails,
} from 'Agent/Commissions/ducks/commissionSchedules';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import Column from 'Shared/components/PagedView/Column';
import {withSelectFilterProperties, withStringFilterProperties} from 'Shared/components/PagedView/Filter';
import PagedView from 'Shared/components/PagedView/PagedView';
import {getSourceOptions} from 'Shared/constants/Source';
import {AgencyFilters} from 'Shared/models/AgencyFilters';
import {withValueChangedHook} from 'Shared/utilities/withValueChanged';
import {useRouteMatch} from 'react-router-dom';
import {useBreadcrumbs} from 'Core/hooks/useBreadcrumbs';

type CommissionSchedulesProps = {
  selectedAgency: AgencyFilters;
};

const CommissionSchedules = (props: CommissionSchedulesProps) => {
  const dispatch = useDispatch();
  const match = useRouteMatch();
  useBreadcrumbs('Commission Schedules', match.url);
  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('md'));
  const {page: schedules, filter} = useSelector((state: ReducerState) => state.schedules);
  const {selectedAgency} = props;

  useEffect(() => {
    dispatch(clearFilters());
    dispatch(clearDetails());

    return () => {
      dispatch(clear());
    };
  }, [selectedAgency]);

  useEffect(() => {
    dispatch(getCommissionSchedules(filter, selectedAgency));
  }, [filter, selectedAgency]);

  const filterProperties = {
    changeFilter: withValueChangedHook(filter, changeFilter, dispatch),
    filterData: filter,
  };

  return (
    <>
      <PagedView
        pagedViewKey="commissionSchedules"
        data={schedules}
        loadMore={page => dispatch(getCommissionSchedules(filter, selectedAgency, page))}
      >
        {columnProps => (
          <>
            <Column
              {...columnProps}
              title="Agent Name"
              filterProperties={withStringFilterProperties(filterProperties, 'agentName')}
              default
            >
              {schedule => schedule.agentName}
            </Column>
            <Column
              {...columnProps}
              title="Agent Number"
              filterProperties={withStringFilterProperties(filterProperties, 'agentNumber')}
              default
            >
              {schedule => schedule.agentNumber}
            </Column>
            <Column
              {...columnProps}
              title="Contract"
              filterProperties={withStringFilterProperties(filterProperties, 'contract')}
              default
            >
              {schedule => schedule.contract}
            </Column>
            <Column
              {...columnProps}
              title="Source"
              filterProperties={withSelectFilterProperties(
                filterProperties,
                'sourceId',
                getSourceOptions(selectedAgency.isNewYork)
              )}
              default
            >
              {schedule => schedule.source?.name}
            </Column>
            <Column {...columnProps} title="" isActions default>
              {schedule => (
                <Button
                  fullWidth={isMobile}
                  color="primary"
                  onClick={() => {
                    dispatch(loadDetails({types: schedule.types!}));
                  }}
                >
                  View Details
                </Button>
              )}
            </Column>
          </>
        )}
      </PagedView>
      <ScheduleDetailsDrawer selectedAgency={selectedAgency} />
    </>
  );
};

export default CommissionSchedules;
